import {
    GET_SHIP_REGION_STATE_REPORT_ERROR,
    GET_SHIP_REGION_STATE_REPORT_REQUEST,
    GET_SHIP_REGION_STATE_REPORT_SUCCESS,
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getOmsShipRegionStateReport = (token, data) => (dispatch) => {



    dispatch({ type: GET_SHIP_REGION_STATE_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getSaleShipOmsCustomerByRegionStateReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: data.from_date,
            to_date: data.to_date,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            customer_type_id: data.customer_type_id === "All" ? null : data.customer_type_id,
            region_id: data.selected_id,
            // region_id: data.selected_id && data.selected_id !== "All" ? data.selected_id.toString() : null,
            company_id: data.company_id,
            state_id: data.select === "true" ? null : data.state_id
        }
    })
        .then((response) => {
            return dispatch({ type: GET_SHIP_REGION_STATE_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SHIP_REGION_STATE_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SHIP_REGION_STATE_REPORT_ERROR,
                payload: error.response,
            });
        });
};
